"use client"
import { useEffect } from 'react'

function loadScript(src: string, attrs: Record<string, string> = {}) {
  const s = document.createElement('script')
  s.async = true
  s.src = src
  Object.entries(attrs).forEach(([k, v]) => s.setAttribute(k, v))
  document.head.appendChild(s)
}

export default function ThirdPartyScriptsClient() {
  useEffect(() => {
    const run = () => {
      try {
      // GA4
      const gaId = process.env.NEXT_PUBLIC_GA_ID || 'G-71SM6K8HCG'
      if (gaId) {
        loadScript(`https://www.googletagmanager.com/gtag/js?id=${gaId}`)
        ;(window as any).dataLayer = (window as any).dataLayer || []
        function gtag(){ (window as any).dataLayer.push(arguments) }
        ;(window as any).gtag = gtag
        gtag('js', new Date())
        gtag('config', gaId)
      }

      // Facebook Pixel
      const pixelId = process.env.NEXT_PUBLIC_FB_PIXEL_ID || ''
      if (pixelId) {
        !(function(f: any,b:any,e:any,v:any,n:any,t:any,s:any){
          if(f.fbq)return; n=f.fbq=function(){ n.callMethod? n.callMethod.apply(n,arguments) : n.queue.push(arguments) };
          if(!f._fbq) f._fbq=n; n.push=n; n.loaded=!0; n.version='2.0'; n.queue=[]; t=b.createElement(e); t.async=!0;
          t.src=v; s=b.getElementsByTagName(e)[0]; s.parentNode!.insertBefore(t,s)
        })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
        try { (window as any).fbq('init', pixelId); (window as any).fbq('track', 'PageView') } catch {}
      }

      // Microsoft Clarity
      const clarityId = process.env.NEXT_PUBLIC_CLARITY_ID || ''
      if (clarityId) {
        (function(c:any,l:any,a:any,r:any,i:any,t:any,y:any){
          c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
          t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
          y=l.getElementsByTagName(r)[0];y.parentNode!.insertBefore(t,y);
        })(window, document, 'clarity', 'script', clarityId)
      }
      } catch {}
    }
    const idle = (window as any).requestIdleCallback as undefined | ((cb: any, opts?: any) => any)
    const id = idle ? idle(run, { timeout: 3000 }) : setTimeout(run, 0)
    return () => { if (!idle) clearTimeout(id as any) }
  }, [])
  return null
}
